<template>
  <div class="p-8">
    <div class="relative flex min-w-0">
      <div class="flex-1">
        <TextArea
          :id="id"
          auto-expand
          :label-name="labelName"
          :model-value="modelValue"
          :disabled="disabled || loading"
          :prevent-enter-default="true"
          prop-classes="!pr-[30px] max-h-[160px]"
          :rows="1"
          @enter="onEnter"
          @update:model-value="emit('update:modelValue', $event)"
        />
      </div>
      <button
        v-if="trimmedValue"
        type="button"
        class="!absolute bottom-[14px] right-[14px] z-10"
        :aria-disabled="disabled || loading"
        aria-label="Send message"
        @click="emit('send')"
      >
        <send-icon aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import TextArea from '@/components/textarea/TextArea.vue';
import SendIcon from '@/graphics/icons/SendIcon.vue';

defineOptions({ name: 'MessageComposer' });

const props = withDefaults(
  defineProps<{
    id?: string;
    labelName?: string;
    modelValue?: string;
    sendLabel?: string;
    disabled?: boolean;
    loading?: boolean;
  }>(),
  {
    id: 'message-composer',
    labelName: 'Message',
    modelValue: '',
    sendLabel: 'Send',
    disabled: false,
    loading: false,
  }
);

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void;
  (event: 'send'): void;
}>();

const trimmedValue = computed(() => props.modelValue.trim());

function onEnter(): void {
  if (trimmedValue.value) emit('send');
}
</script>
